import { Box, Card, CardContent, IconButton, Skeleton, Tooltip, Typography } from '@mui/material';
import { FC, useState } from 'react';
import { useSelector } from 'react-redux';
import {
	getConfirmedOrders,
	getConfirmedOrdersLoader,
	getOrderDetailsCombined,
	getOrderDetailsCombinedLoader,
} from 'redux/reducers/orders/selectors';
import AddBoxIcon from '@mui/icons-material/AddBox';
import IndeterminateCheckBoxIcon from '@mui/icons-material/IndeterminateCheckBox';
import { useParams } from 'react-router';
import { AmountAndCurrency } from 'ui/AmountAndCurrency';
import { OrderDetailsRow } from './OrderDetailsRow';

export const OrderDetails: FC = () => {
	const params = useParams<{ orderId?: string }>();
	const { orderId } = params;

	const orderDetailsCombined = useSelector(getOrderDetailsCombined);
	const orderDetailsCombinedIsLoading = useSelector(getOrderDetailsCombinedLoader);
	const orders = useSelector(getConfirmedOrders);
	const ordersIsLoading = useSelector(getConfirmedOrdersLoader);
	const orderDetails = orderDetailsCombined?.orderDetails;

	const [detalization, setDetalization] = useState(false);
	const handleDetalization = () => {
		setDetalization(!detalization);
	};

	return (
		<div>
			{!!orderDetails?.length &&
				!ordersIsLoading &&
				!orderDetailsCombinedIsLoading &&
				!!orders?.data?.length &&
				String(orders?.data?.[0]?.id) === orderId && (
					<Card
						sx={{
							mb: 2,
							'&': {
								borderRadius: '12px',
							},
						}}
					>
						<CardContent>
							<Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
								<Typography sx={{ fontSize: 14 }} color="primary" gutterBottom>
									Order Details
								</Typography>
								{detalization ? (
									<Tooltip title="Hide more details">
										<IconButton size="small" color="primary" onClick={handleDetalization}>
											<IndeterminateCheckBoxIcon />
										</IconButton>
									</Tooltip>
								) : (
									<Tooltip title="Show more details">
										<IconButton size="small" color="primary" onClick={handleDetalization}>
											<AddBoxIcon />
										</IconButton>
									</Tooltip>
								)}
							</Box>

							<Typography variant="h6" component="div">
								{orderDetails.map((item, index) => (
									<OrderDetailsRow
										key={item?.description ?? index}
										orderDetailsRow={item}
										paymentCurrency={orders?.data?.[0]?.paymentCurrency}
										detalization={detalization}
									/>
								))}
							</Typography>
							{orderDetails.length > 1 && (
								<Box
									sx={{
										mt: 1.5,
										display: 'flex',
										justifyContent: 'space-between',
										alignItems: 'center',
										border: '1px solid #00000020',
										borderRadius: '12px',
										padding: '10px',
									}}
								>
									<Typography variant="h6" sx={{ fontWeight: 'bold' }} color="primary">
										Total Amount:
									</Typography>
									<AmountAndCurrency
										amount={orders?.data?.[0]?.totalOrderValue ?? 0}
										currency={orders?.data?.[0]?.paymentCurrency}
										bold
										size={1.3}
										color="primary"
									/>
								</Box>
							)}
						</CardContent>
					</Card>
				)}
			{(ordersIsLoading || orderDetailsCombinedIsLoading) && (
				<Skeleton variant="rectangular" height="350px" sx={{ borderRadius: '12px', mb: 2 }} />
			)}
		</div>
	);
};
